/**
 * @generated SignedSource<<e7828732534b65aa9eceee74602590b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContactActivityView_contact$data = {
  readonly contactIdentifier: string;
  readonly id: string;
  readonly " $fragmentType": "ContactActivityView_contact";
};
export type ContactActivityView_contact$key = {
  readonly " $data"?: ContactActivityView_contact$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContactActivityView_contact">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContactActivityView_contact",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contactIdentifier",
      "storageKey": null
    }
  ],
  "type": "Contact",
  "abstractKey": "__isContact"
};

(node as any).hash = "080c6200014e8949ca5e38bcbe8f2717";

export default node;
